/* eslint-disable @typescript-eslint/no-unused-vars */
import { createContext, SetStateAction } from 'react';
import { PanelViews } from '../../shared/types/enums/PanelViews';
import { ISidePanelContext } from './ISidePanelContext';

export default createContext<ISidePanelContext>({
  isOpen: false,
  setIsOpen: (isOpen: SetStateAction<boolean>): void => {
    throw new Error(' (isOpen: SetStateAction<boolean>): void');
  },
  currentView: PanelViews.Scheduler,
  setCurrentView: (currentView: SetStateAction<PanelViews>): void => {
    throw new Error(' (currentView: SetStateAction<PanelViews>): void');
  },
  isInvoicingPanelDirty: false,
  setIsInvoicingPanelDirty: (isDirty: SetStateAction<boolean>): void => {
    throw new Error(' (isDirty: SetStateAction<boolean>): void');
  },
  isZIndexIncreased: false,
  setIsZIndexIncreased: (isZIndexIncreased: SetStateAction<boolean>): void => {
    throw new Error(' (isZIndexIncreased: SetStateAction<boolean>): void');
  },
});
